export default __webpack_public_path__ + "static/media/tommy-hearns-news.8fc9c375.png";